<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>类别</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 搜索区域 -->
            <!-- 搜索和添加区域 -->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-input placeholder="请输入搜索内容" v-model="queryInfo.query" class="input-with-select" clearable >
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </el-col>

      </el-row>

      <!-- 列表区域 -->
      <el-table :data="list" border  style="width: 100%"  >       
        <el-table-column prop="id" label="id" width="50px"></el-table-column>
        <el-table-column prop="type" label="类别">           
          </el-table-column>        
        <el-table-column prop="no" label="排序"></el-table-column>        
        <el-table-column prop="color" label="颜色"></el-table-column>      
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="edituser(scope.row,scope.$index)">编辑</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deluser(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="center"
      >
      </el-pagination>
    </el-card>
<!-- 添加联系人对话框 -->
    <el-dialog title="编辑" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" ref="addFormRef" label-width="80px">
        <el-form-item label="类别" prop="title">
          <el-input v-model="addForm.type" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="no">
          <el-input v-model="addForm.no" ></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="imgsrc">
           <el-select @change="change" v-model="addForm.colorsm" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
     
        </el-form-item>
      
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button @click="saveuser()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mqtt from 'mqtt'
import glob_Data from '@/public/global_data.js' //导入全局变量	
import {formatDate} from "@/common/tool.js"

export default {
  components: {},
  data() {
    return {    
     
      // 获取列表参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      list: [
        
      ],
      value: true,
      total: 0, 
      // 控制添加用户对话框的显示或隐藏
      addDialogVisible: false,

      // 添加用户
      addForm: {

 
      },

      // 控制修改用户对话框的显示或隐藏
      editDialogVisible: false,

      // 查询到的用户
      editForm: {},
      options: [{
          value: 'num-1',
          label: '橙'
        },
        {
          value: 'num-2',
          label: '蓝'
        },
        {
          value: 'num-3',
          label: '灰'
        },
        {
          value: 'num-4',
          label: '红'
        },
        {
          value: 'num-5',
          label: '黄'
        },
        {
          value: 'num-6',
          label: '绿'
        },
        {
          value: 'num-7',
          label: '深蓝'
        },
        {
          value: 'num-8',
          label: '紫'
        },
        {
          value: 'num-9',
          label: '粉红'
        },
      ]

    }
  },
  async created() {        
      this.getList();
  },
  methods: {
    change(res){
      console.log(res);
      var index=this.options.findIndex((item)=>{return item.value==res});
      this.addForm.color=this.options[index].label;
    }, 
    saveuser(){
         let _this = this
         var serverurl = glob_Data.globaldata.serverurl;
         let url = serverurl+"ctl_type_ht.fsp?proc=save";                
         url+="&token="+ localStorage.getItem("token");        
         console.log(url) ;


        var sendata=this.addForm;
        this.$http({
          method: "post",//指定请求方式
          url: url,
          data:sendata          
        })
        .then(function(res){
          //接口成功返回结果执行
          if (res.data.errno!=0){
           _this.$alert(res.data.errmsg, '系统提示');          
           return;
          }          
          _this.fileList=[];
          if (_this.addForm.index!=-1){
             //_this.list[_this.addForm.index]=res.data.rows[0];
             _this.list.splice(_this.addForm.index,1,res.data.rows[0])
          }else{
            _this.list.push(res.data.rows[0])
          }
            _this.addDialogVisible = false
        })
        .catch(function(err){
            //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
             _this.$alert(err, '系统错误');     
        })   
    },  
    deluser(item,index){
         let _this = this;
        this.$confirm('是否确认删除当前行？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '放弃'
        })
          .then(() => {
                console.log("fff");
                var serverurl = glob_Data.globaldata.serverurl;
                let url = serverurl+"ctl_type_ht.fsp?proc=save";  
                url+="&token="+ localStorage.getItem("token");                        
                var senddata=item;
                senddata.qystatus="del"
                this.$http({
                  method: "post",//指定请求方式
                  url: url,
                  data:senddata          
                })
                .then(function(res){
                  //接口成功返回结果执行
                  if (res.data.errno!=0){
                  _this.$alert(res.data.errmsg, '系统提示');          
                  return;
                  }
                  _this.list.splice(index,1);
                  _this.$message({
                    type: 'info',
                    message: '删除成功'
                  });
                })
                .catch(function(err){
                    //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
                    _this.$alert(err, '系统错误');     
                })   

          })
          .catch(action => {  
          });     
     
    },
    edituser(item,index){
       console.log(index);
       
       this.addForm=item;
       this.addForm.index=index;      
       this.addDialogVisible=true;
       console.log(this.addForm);
    },
    // 获取列表数据
        getList() {
            var serverurl = glob_Data.globaldata.serverurl;
            let url = serverurl+"ctl_type_ht.fsp?proc=getlist"
            url+="&token="+ localStorage.getItem("token");        
          // Vue.prototype.$http = axios;
            var senddata={
              pagenum:this.queryInfo.pagenum,
              pagesize:this.queryInfo.pagesize,
              query:this.queryInfo.query
            }
            let _this = this
            this.$http.get(url, {
            // emulateJSON:false,
              params:senddata
            }).then(function (res) {            
              if(res.data.errno!=0){
                  _this.$alert(res.data.errmsg,"系统提示");
                  return;
              }
                _this.list = res.data.rows;
                _this.total=res.data.total;
                var myrows=res.data.rows;              

            }).catch(function (error) {

            })
        },
        handleSizeChange(e) {
          console.log(e)
          this.queryInfo.pagesize=e;
          this.getList()
        },
        handleCurrentChange(e) {
          console.log(e)
          this.queryInfo.pagenum=e;
          this.getList()
        },
            //监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },  
      
    
  },
}
</script>
<style>

.table {
  width: 900px;
  height: 400px;
  margin: 100px auto;
}

/*更改表格颜色*/
.alert {
  background: #f9fd00 !important;
}
.zero {
  background: rgb(255, 255, 255) !important;
}
.notzero {
  background: rgb(128, 1, 1) !important;
}

</style>
